// extracted by mini-css-extract-plugin
export default {"button":"style_button__pEfPR","modelTwo":"style_modelTwo__Ygg3c","centered":"style_centered__bL51W","inputHighlighter":"style_inputHighlighter__i7chj"};